import PDFDocument from 'pdfkit/js/pdfkit.standalone.js';

export function renderLine(pdf: PDFDocument, color: string, lineWeight: number) {
	pdf.save();

	const lineWidth = pdf.page.width - pdf.page.margins.left - pdf.page.margins.right;

	pdf.rect(pdf.x, pdf.y, lineWidth, lineWeight).fill(color);

	pdf.restore();
}
